import { render, staticRenderFns } from "./RsaRiepilogoPresenzeListComponent.vue?vue&type=template&id=abf2544c&scoped=true"
import script from "./RsaRiepilogoPresenzeListComponent.vue?vue&type=script&lang=js"
export * from "./RsaRiepilogoPresenzeListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf2544c",
  null
  
)

export default component.exports